


















import { Component, Vue, Prop } from "vue-property-decorator";
import { ActiveSynergy } from "@/models/type";
@Component({
  name: "synergy-count-item",
  components: {
    "synergy-tooltip": () => import("@/components/Molecules/SynergyTooltip.vue")
  }
})
export default class SynergyCountItemActive extends Vue {
  @Prop({ required: true }) type!: "origin" | "class";
  @Prop({ required: true }) synergy!: ActiveSynergy;
}
